// @flow
import scrollToEl from "./scrollToEl";
const scrollToAnchor = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
        scrollToEl(element);
    }
};
window.sta = scrollToAnchor;

export default scrollToAnchor;
